import { Menu } from '@dynameat/views/pointOfSale/models';
import * as api from './api';
import * as MutationTypes from './mutationTypes';
import { ProductItem, Section } from './models';
import * as processes from './processes';

export const menuRequest = async ({ commit, getters: { currentMenu } }, menuGuid) => {
  if (!currentMenu || currentMenu.guid !== menuGuid) {
    const response = await api.menuRequest(menuGuid);
    const payload = Menu.toInstance(response.data);
    commit(MutationTypes.MENU_SUCCESS, payload);
  }
};

export const loadSection = async ({ commit, getters: { getSectionByGuid } }, { menuGuid, sectionGuid }) => {
  const { section, sectionList } = await processes.getSection(menuGuid, sectionGuid);

  commit(MutationTypes.SECTION_SUCCESS, { section, sectionList });

  const { newClause, newSection } = await processes.breadCrumbRequest(getSectionByGuid, section);
  commit(MutationTypes.BREADCRUMB_SUCCESS, { parentClause: newClause, parentSection: newSection });
};

export const createSection = async ({ commit }, section) => {
  const response = await api.createSectionRequest(section.serialize());
  const newSection = new Section(response.data);
  commit(MutationTypes.CREATE_SECTION, newSection);
};

export const editSection = async ({ commit, getters: { getSectionByGuid } }, section) => {
  await api.editSectionRequest(section.guid, section.serialize());
  const parent = getSectionByGuid(section.parent_section);
  commit(MutationTypes.EDIT_SECTION, { section, parent });
};

export const deleteSection = async ({ commit, getters: { getSectionByGuid } }, section) => {
  await api.deleteSectionRequest(section.guid);
  const parent = getSectionByGuid(section.parent_section);
  commit(MutationTypes.DELETE_SECTION, { section, parent });
  commit(MutationTypes.REORDER_SECTION_CONTENTS, { section: parent, order: section.order });
};

export const resetMenuEditor = ({ commit }) => {
  commit(MutationTypes.RESET_MENU_EDITOR);
};

export const createProduct = async ({ commit }, product) => {
  const response = await api.createProductRequest(product);
  const newProduct = new ProductItem(response.data);
  commit(MutationTypes.CREATE_PRODUCT, newProduct);
};

export const editProduct = async ({ commit }, product) => {
  const response = await api.editProductRequest(product.guid, product);
  const editedProduct = new ProductItem(response.data);
  commit(MutationTypes.EDIT_PRODUCT, editedProduct);
};

export const deleteProduct = async ({ commit, getters: { getSectionByGuid } }, product) => {
  await api.deleteProductRequest(product.guid);
  const parent = getSectionByGuid(product.section);
  commit(MutationTypes.DELETE_PRODUCT, product);
  commit(MutationTypes.REORDER_SECTION_CONTENTS, { section: parent, order: product.default_order });
};

export const reorderItems = async ({ commit }, { oldItemsList, newItemsList }) => {
  commit(MutationTypes.REORDER_ITEMS, newItemsList);
  await processes.reorderItems(oldItemsList, newItemsList);
};

export const moveItem = async ({ commit, getters: { currentSection, currentSectionList } }, { item, value }) => {
  const res = await processes.moveItem(currentSection, currentSectionList, item, value);
  item = res.item;
  const { swappedItem } = res;
  commit(MutationTypes.MOVE_ITEM, { itemOne: item, itemTwo: swappedItem });
};

export const editMenu = ({ commit }, menu) => {
  commit(MutationTypes.EDIT_MENU, menu);
  return menu;
};

export const editTheme = ({ commit }, theme) => {
  commit(MutationTypes.EDIT_THEME, theme);
  return theme;
};
